/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SharedAntdTable from '../../common/shared-antd-table/SharedAntdTable';
import sharedRouterLinks from '../../components/app/shared-routes/sharedRouterLinks';
import UserContext from '../../contexts/user-context/UserProvider';
import {
  setConfirmModal,
  setDeleteModalOpened,
  setEditEndDateModalOpened,
  setPostFormModalOpened,
  setSelectedTableRow
} from '../../redux/clients-slice/clientsSlice';
import ClientsTableColumns from './ClientsTableColumns';
import queryString from 'query-string';

const ClientsPageTable = ({ fetchedTableData, tablePagination }) => {
  const { search } = useLocation();
  const values = queryString.parse(search);
  const { i18n } = useTranslation();
  const { user } = useContext(UserContext);
  const dispatch = useDispatch();
  // const fetchedTableData = useSelector(
  //   (store) => store.clients.fetchedTableData
  // );
  const deleteModalOpened = useSelector(
    (store) => store.clients.deleteModalOpened
  );
  const editEndDateModalOpened = useSelector(
    (store) => store.clients.editEndDateModalOpened
  );
  const isLoadingTableData = useSelector(
    (store) => store.clients.isLoadingTableData
  );

  // map all data to dataSource
  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id
    }));
  };
  useEffect(() => {
    let isMounted = true;

    if (fetchedTableData?.length >= 0) {
      const mappedData = mapDataSource(fetchedTableData);
      if (isMounted) {
        setTableDataSource(mappedData);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [fetchedTableData]);

  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  return (
    <SharedAntdTable
      showHeader={true}
      className={`recent-clients-table ${i18n.dir()}`}
      hasPagination={true}
      tableDataSource={tableDataSource}
      tableColumns={ClientsTableColumns}
      allFetchedTableData={fetchedTableData}
      setFormModalOpened={() => dispatch(setPostFormModalOpened(true))}
      // setDetailsModalOpened={setDetailsModalOpened}
      //
      deleteModalOpened={deleteModalOpened}
      setEditEndDateModalOpened={() => dispatch(setEditEndDateModalOpened(true))}

      editEndDateModalOpened={editEndDateModalOpened}
      setDeleteModalOpened={(v) => dispatch(setDeleteModalOpened(v))}
      setSelectedTableRow={(v) => dispatch(setSelectedTableRow(v))}
      setConfirmModal={(v) => dispatch(setConfirmModal(v))}
      //
      isLoadingTableData={isLoadingTableData}
      user={user}
      tablePagination={tablePagination}
      baseTablePageUrl={`${sharedRouterLinks?.appClientsRoute}?package_id=${
        values?.package_id || ''
      }&searchText=${values?.searchText || ''}&sort=${values?.sort || ''}`}
    />
  );
};

export default ClientsPageTable;
